import { useSearchParams } from 'next/navigation';
import { CLIENT_ID_KEY } from '../data';

export function useClientId() {
  const queryParams = useSearchParams();

  function saveClientIdToStorage(clientId: string) {
    try {
      sessionStorage.setItem(CLIENT_ID_KEY, clientId);
    } catch (e) {
      console.warn('Could not save client id to localStorage', e);
    }
  }

  function readClientIdFromUrl() {
    return queryParams?.get('clientId');
  }

  function readClientIdFromStorage() {
    if (typeof window === 'undefined') return null;

    return sessionStorage.getItem(CLIENT_ID_KEY);
  }

  function readClientIdFromUrlOrStorage() {
    return readClientIdFromUrl() || readClientIdFromStorage();
  }

  return {
    readClientIdFromUrlOrStorage,
    readClientIdFromStorage,
    readClientIdFromUrl,
    saveClientIdToStorage,
  };
}
